import styled from "styled-components";

export const ServiceDurationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .duration-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
  }

  .duration-title {
    font-weight: 600;
    font-size: 0.875rem;
  }

  .duration-options {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .duration-chip {
    padding: 0.375rem 0.75rem;
    border: 1px solid #e0e2e6;
    border-radius: 1.5rem;
    background: #fff;
    cursor: pointer;
    font-size: 0.8125rem;

    &.active {
      border-color: #1a1a2e;
      background: #f5f5f7;
    }
  }

  .custom-duration {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .schedule-card {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
    border-radius: 0.5rem;
    border-left: 3px solid #4338ca;
    background: #f5f7fa;
  }

  .schedule-card-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;

    p {
      margin: 0;
      font-size: 0.8125rem;
      color: #4a4f57;
      line-height: 1.4;
    }
  }

  .schedule-card-button {
    align-self: flex-start;
    border: none;
    background: none;
    color: #4338ca;
    font-size: 0.8125rem;
    font-weight: 600;
    cursor: pointer;
    text-decoration: underline;
    padding: 0;
  }

  .schedule-card-close {
    border: none;
    background: none;
    color: #8b919a;
    cursor: pointer;
    padding: 0;
    flex-shrink: 0;
  }

  .schedule-edit-link {
    align-self: flex-start;
    border: none;
    background: none;
    color: #4338ca;
    font-size: 0.8125rem;
    font-weight: 500;
    cursor: pointer;
    text-decoration: underline;
    padding: 0;
  }
`;
